import _ from 'lodash';
import React, { useMemo, useEffect, useState } from 'react';

const SingleTextEditor = ({
  className = '',
  small = false, value,
  label = null,
  debounceMs = null,
  placeholder = '',
  onChange,
  onBlur = (any) => null,
  ...otherProps
}) => {
  const debouncedOnChange = useMemo(() => {
    if (debounceMs) {
      return _.debounce(onChange, debounceMs);
    }
    return onChange;
  }, [onChange, debounceMs]);

  useEffect(() => {
    return () => {
      if (debounceMs) {
        debouncedOnChange.cancel();
      }
    };
  }, [debouncedOnChange, debounceMs]);

  useEffect(() => {
    if(debounceMs) {
      setDebouncedValue(value);
    }
  }, [value]);

  const [debouncedValue, setDebouncedValue] = useState(value);

  let extraClasses = ' ';

  if (!label) {
    extraClasses += className;
  }

  if (small) {
    extraClasses += ' form-control-sm'
  }

  const input = <input type={'text'} className={'form-control' + (true ? '' : 'text-danger') + extraClasses}
    spellCheck="false"
    onChange={e => {
      if(debounceMs) {
        setDebouncedValue(e.target.value);
      } 
      debouncedOnChange(e.target.value);
    }}
    onBlur={e => onBlur(e.target.value)}
    value={debounceMs ? debouncedValue : value || ""} placeholder={placeholder}
    {...otherProps}
  />;

  if (label) {
    return <div className={"input-group" + (small ? ' input-group-sm ' : ' ') + (className || "")}>
      <div className="input-group-prepend">
        <span className="input-group-text" id="basic-addon1">{label}</span>
      </div>
      {input}
    </div>
  } else {
    return input
  }
};

export default SingleTextEditor;
